import { Box, Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { styled } from "@mui/system";

const heroBakgroundImage = "/assets/img/list-equ.png";

const StyledBoxImage = styled(Box)(({ theme }) => ({
  backgroundImage: `url(${heroBakgroundImage})`,
  backgroundSize: "cover",
  height: "auto",
  position: "relative",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "top",
  display: "flex",
  alignItems: "center",
  textAlign: "left",
  width: "100%",
  //   padding: "100px 0",

  "& h1": {
    fontSize: "64px",
    fontFamily: "Inter",
    color: theme.palette.custom.background.dark.light,
    padding: 0,
    margin: "0 0 20px",
    "@media only screen and (min-width: 320px) and (max-width: 768px)": {
      fontSize: 26,
      lineHeight: "36px",
    },
  },
}));

const StyledBoxHeader = styled(Box)(({ theme }) => ({
  fontSize: "15px",
  fontFamily: "Inter",
  borderRadius: "8px",
  color: theme.palette.common.white,
  padding: "5px 20px",
  lineHeight: "40px",
  height: "40px",
  backgroundColor: theme.palette.custom.background.dark.light,
  boxShadow: "0 6px 16px 0 rgba(0,0,0,0.06)",
  display: "inline-flex",
  fontWeight: 400,
  flexWrap: "wrap",
  [theme.breakpoints.down("sm")]: {
    fontSize: "10px",
    lineHeight: "35px",
    padding: "2.5px",
  },
  [theme.breakpoints.down("md")]: {
    padding: "5px",
    fontWeight: 500,
  },
  //   "@media only screen and (min-width: 320px) and (max-width: 768px)": {
  //     fontSize: 26,
  //     lineHeight: "36px",
  //   },
}));

const HeroSection = () => {
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <StyledBoxImage>
      <Grid
        container
        spacing={1}
        sx={{
          background:
            "radial-gradient(97.49% 391.18% at 8.24% 13.92%, #D1E7F7 0%, rgba(209, 231, 247, 0) 100%)",
          padding: {
            md: "100px",
            lg: "100px",
            xl: "100px",
            sm: "50px 10px",
            xs: "50px 10px",
          },
        }}
      >
        <Grid item xs={12} sm={12}>
          <Box
            sx={{
              background: "#383838",
              borderRadius: "10px",
              height: "40px",
              width: "160px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "#FFF", fontSize: "13px" }}>
              List Your Equipment
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Typography
            sx={{
              fontSize: {
                md: "64px",
                lg: "64px",
                xl: "64px",
                sm: "28px",
                xs: "28px",
              },
              fontWeight: 700,
              lineHeight: {
                md: "80px",
                lg: "80px",
                xl: "80px",
                sm: "38px",
                xs: "38px",
              },
              width: {
                md: "60%",
                lg: "60%",
                xl: "60%",
                sm: "100%",
                xs: "100%",
              },
            }}
          >
            Boost Your Profit to List Your Equipments For Renting
          </Typography>
          <Typography
            sx={{
              fontSize: "17px",
              fontWeight: 500,
              lineHeight: "24px",
              width: {
                md: "50%",
                lg: "50%",
                xl: "50%",
                sm: "100%",
                xs: "100%",
              },
              mt: "20px",
            }}
          >
            Maximize your earning potential by listing your equipment for
            renting. Earn extra income effortlessly while providing valuable
            services to others in need.
          </Typography>
        </Grid>
      </Grid>
    </StyledBoxImage>
  );
};

export default HeroSection;
